import React from "react";

/**
 * ExactWorkersCompNoticeBilingual
 *
 * Renders the exact bilingual "Notice to Employees" / "Aviso a los Empleados"
 * poster, matching every word, punctuation mark, and layout detail from the official image.
 * You can remove or replace the inline `style={{…}}` props with your own CSS/Tailwind classes
 * (e.g. .posterContainer, .sectionHeader, .dividerRow, etc.) to fit your site's styling.
 */
const ExactWorkersCompNoticeBilingual = () => {
  return (
    <div
      className="posterContainer"
      style={{
        border: "1px solid #000",
        padding: "1rem",
        maxWidth: 800,
        margin: "0 auto",
        fontFamily: "'Helvetica Neue', Arial, sans-serif",
        lineHeight: 1.4,
      }}
    >
      {/* Top Header with posting instructions and policy/issued info */}
      <div
        className="topHeader"
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "0.75rem",
          fontSize: "0.9rem",
        }}
      >
        <span>TO BE POSTED BY EMPLOYER</span>
        <span>POLICY NUMBER (6JUB-0W96640-1-25)</span>
      </div>
      <div
        className="issuedTo"
        style={{ marginBottom: "1rem", fontSize: "0.9rem" }}
      >
        ISSUED TO: SCOTT BUSINESS GROUP LLC
      </div>

      {/* English Section */}
      <h1
        className="sectionTitle"
        style={{
          textAlign: "center",
          marginBottom: "0.5rem",
          fontWeight: "bold",
        }}
      >
        NOTICE TO EMPLOYEES
      </h1>
      <h2
        className="sectionSubtitle"
        style={{
          textAlign: "center",
          marginBottom: "1rem",
          fontSize: "1rem",
          fontWeight: 600,
        }}
      >
        RE: ARIZONA WORKERS' COMPENSATION LAW
      </h2>

      <p className="englishPara1" style={{ marginBottom: "0.75rem" }}>
        All employees are hereby notified that this employer has complied with the
        provisions of the Arizona Workers' Compensation Law (Title 23, Chapter 6,
        Arizona Revised Statutes) as amended, and all the rules and regulations of
        The Industrial Commission of Arizona made in pursuance thereof, and has
        secured the payment of compensation to employees by insuring the payment of
        such compensation with: <strong>THE TRAVELERS INSURANCE COMPANIES</strong>
      </p>

      <p className="englishPara2" style={{ marginBottom: "1rem" }}>
        All employees are hereby further notified that in the event they do not
        specifically reject the provisions of the said compulsory law, they are
        deemed by the laws of Arizona to have accepted the provisions of said law
        and to have elected to accept compensation under the terms thereof; and that
        under the terms thereof employees have the right to reject the same by
        written notice thereof prior to any injury sustained, and that the blanks
        and forms for such notice are available to all employees at the office of
        this employer.
      </p>

      {/* Divider Row of Asterisks */}
      <div
        className="dividerRow"
        style={{
          textAlign: "center",
          margin: "0.75rem 0",
          fontSize: "1rem",
        }}
      >
        * * * * * * * * * * * * * * * * * *
      </div>

      {/* Spanish Section */}
      <div
        className="topHeaderEs"
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "0.75rem",
          fontSize: "0.9rem",
        }}
      >
        <span>PARA SER COLOCADO POR EL PATRÓN</span>
        <span>NUMERO DE PÓLIZA (6JUB-0W96640-1-25)</span>
      </div>

      <h1
        className="sectionTitleEs"
        style={{
          textAlign: "center",
          marginBottom: "0.5rem",
          fontWeight: "bold",
        }}
      >
        AVISO A LOS EMPLEADOS
      </h1>
      <h2
        className="sectionSubtitleEs"
        style={{
          textAlign: "center",
          marginBottom: "1rem",
          fontSize: "1rem",
          fontWeight: 600,
        }}
      >
        RE: LEY DE COMPENSACIÓN PARA LOS TRABAJADORES DE ARIZONA
      </h2>

      <p className="spanishPara1" style={{ marginBottom: "0.75rem" }}>
        A todos los empleados se les notifica por este medio que este patrón ha
        cumplido con las disposiciones de la Ley de Compensación para los
        Trabajadores de Arizona (Título 23, Capítulo 6, Estatutos Enmendados de
        Arizona) tal como han sido enmendados, y con todas las reglas y ordenanzas de
        La Comisión Industrial de Arizona hechas en cumplimiento de ésta, y ha
        asegurado el pago de compensación a los empleados garantizando el pago de
        dicha compensación por medio de: <strong>THE TRAVELERS INSURANCE COMPANIES</strong>
      </p>

      <p className="spanishPara2" style={{ marginBottom: "1rem" }}>
        Además, a todos los empleados se les notifica por este medio que en caso de
        que específicamente ellos no rechacen las disposiciones de dicha ley
        obligatoria, se les considerará bajo las leyes de Arizona de haber aceptado
        las provisiones de dicha ley y de haber escogido aceptar la compensación bajo
        estos términos; también bajo estos términos los empleados tienen el derecho
        de rechazar la misma por medio de una notificación por escrito antes de que
        sufran alguna lesión, todos los formularios o formas en blanco para tal
        notificación por escrito estarán disponibles para todos los empleados en la
        oficina de este patrón.
      </p>

      {/* Divider Row of Asterisks */}
      <div
        className="dividerRowEs"
        style={{
          textAlign: "center",
          margin: "0.75rem 0",
          fontSize: "1rem",
        }}
      >
        * * * * * * * * * * * * * * * * * *
      </div>

      {/* Bottom Notice */}
      <p
        className="bottomNotice"
        style={{
          textAlign: "center",
          fontWeight: 600,
          marginTop: "1rem",
          fontSize: "1rem",
        }}
      >
        KEEP POSTED IN A CONSPICUOUS PLACE. COLOQUESE EN LUGAR VISIBLE.
      </p>

      {/* Footer Codes */}
      <div
        className="footerCodes"
        style={{
          display: "flex",
          justifyContent: "flex-start",
          marginTop: "1.5rem",
          fontSize: "0.75rem",
        }}
      >
        <span>000262&nbsp;&nbsp;</span>
        <span>W02P1A96</span>
      </div>
    </div>
  );
};

export default ExactWorkersCompNoticeBilingual;